module.exports = __webpack_public_path__ + "static/contact-77043915542db59331132cde909efd02.jpeg";